"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var A11yDescription = _styledComponents["default"].span.withConfig({
  displayName: "A11yDescription",
  componentId: "sc-1s3drv3-0"
})([""]);

var CloseButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1s3drv3-1"
})(["position:relative;padding:16px;height:56px;width:56px;overflow:hidden;& > ", "{object-fit:contain;object-position:center center;position:absolute;}& > ", "{text-indent:9999em;}"], _baseReactComponents.Icon, A11yDescription);

var ScreenContent = _styledComponents["default"].div.withConfig({
  displayName: "ScreenContent",
  componentId: "sc-1s3drv3-2"
})(["overflow:auto;"]);

var ScreenWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScreenWrapper",
  componentId: "sc-1s3drv3-3"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:stretch;pointer-events:all;width:100%;height:100%;background:", ";& > ", "{flex:0 0 auto;align-self:flex-end;margin:8px;}& > ", "{flex:1 0 0;align-self:stretch;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.white;
}, CloseButton, ScreenContent);

var Screen = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(function (_ref2) {
  var _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
      _ref2$closeIcon = _ref2.closeIcon,
      closeIcon = _ref2$closeIcon === void 0 ? 'actions/close' : _ref2$closeIcon,
      closeIconColor = _ref2.closeIconColor,
      _ref2$closeDescriptio = _ref2.closeDescription,
      closeDescription = _ref2$closeDescriptio === void 0 ? 'close menu' : _ref2$closeDescriptio,
      children = _ref2.children,
      className = _ref2.className,
      theme = _ref2.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ScreenWrapper, {
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(CloseButton, {
      variation: "noOutline",
      onClick: onClose,
      "data-testid": "full-screen-filter:close-button",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(A11yDescription, {
        children: closeDescription
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: closeIcon,
        color: closeIconColor !== null && closeIconColor !== void 0 ? closeIconColor : theme.scuttleGray600,
        height: "24",
        width: "24"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ScreenContent, {
      children: children
    })]
  });
})).withConfig({
  displayName: "Screen",
  componentId: "sc-1s3drv3-4"
})([""]);
exports.Screen = Screen;
//# sourceMappingURL=screen.js.map